import { Stack } from '@cp/ds/src/components/stack';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { MOBILE_BREAKPOINT_THRESHOLD } from '@cp/ds/src/theme';
import { ButtonProps } from '@cp/ds/src/components/button/model';
import { Button } from '@cp/ds/src/components/button';
import { clientTypeToSuitableCatalogItemType } from '@common/utils/catalogType';
import { useClientProfile } from 'src/entities/client';
import { withSubscriptionClick } from 'src/features/billing';
import { withTrackClick } from 'src/shared/tracking';
import { CatalogEvents } from 'src/features/catalog';
import { withAuth } from 'src/features/auth';
import { __experimentalComponentBuilder as componentBuilder } from 'src/shared/componentBuilder';
import { catalogItemConnectToIntent, withConnectCatalogItemIntent, withOrderNannyClick } from 'src/features/catalogItem';
import { FC } from 'react';
import { ClientType } from '@common/model/client/clientType';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { ConnectButton, ResponseButton } from 'src/widgets/catalog';
import { CatalogItemActionsProps } from './model';
import { Favorite, FavoriteProps } from './favorite';

export * from './model';

const resumeButtonProps: ButtonProps = {
  color: 'gray',
  size: 'normal',
  sx: { flex: 1 },
  variant: 'primary',
};

const InviteButton = componentBuilder(Button)
  .compose(withOrderNannyClick)
  .compose(withSubscriptionClick)
  .compose(withAuth)
  .compose(withConnectCatalogItemIntent)
  .composeWithArgs(withTrackClick, CatalogEvents.ItemInvite)
  .buildWithProps(resumeButtonProps);

const ResumeActions: FC<ButtonProps & { catalogItem: CatalogItemViewModel }> = ({ catalogItem, ...props }) => (
  <>
    <Stack direction="row" spacing={1.5} sx={{ maxWidth: '480px', width: '100%', px: { xs: '12px', md: 0 }, mt: { xs: 0, md: '20px' } }}>
      <InviteButton
        careerId={catalogItem.careerId}
        catalogItemId={catalogItem.id}
        clientType={ClientType.Employer}
        data-intent={catalogItemConnectToIntent(catalogItem.id)}
      >
        Позвать
      </InviteButton>
      <ConnectButton
        {...resumeButtonProps}
        careerId={catalogItem.careerId}
        catalogItemId={catalogItem.id}
        clientType={ClientType.Employer}
        data-intent={catalogItemConnectToIntent(catalogItem.id)}
        sx={{ ...resumeButtonProps.sx, borderWidth: 1, borderStyle: 'solid', borderColor: 'brand gray' }}
      >
        Написать
      </ConnectButton>
    </Stack>
    {catalogItem.clientProfile && (
      <Favorite color="gray ultra light" {...(props as FavoriteProps)} authorId={catalogItem.clientProfile.id} />
    )}
  </>
);

const VacancyActions: FC<ButtonProps & { catalogItem: CatalogItemViewModel }> = ({ catalogItem, ...props }) => {
  return (
    <>
      <ResponseButton catalogItemId={catalogItem.id} color="pink" {...props}>
        Я могу
      </ResponseButton>
      <ConnectButton {...props} catalogItemId={catalogItem.id} color="white" data-intent={catalogItemConnectToIntent(catalogItem.id)}>
        Задать вопрос
      </ConnectButton>
    </>
  );
};

/**
 * @deprecated use actions based on catalog type from widgets/catalog
 */
export const CatalogItemActions: FC<CatalogItemActionsProps> = ({ sx, catalogItem: originalCatalogItem }) => {
  const clientProfile = useClientProfile();
  const catalogItem = originalCatalogItem;

  if (!catalogItem) {
    return null;
  }

  const isResume = catalogItem.type === CatalogItemType.Resume;
  const buttonsProps: ButtonProps = {
    sx: isResume ? {} : { flex: { xs: '1 1 50%', [MOBILE_BREAKPOINT_THRESHOLD]: 'initial' }, whiteSpace: 'nowrap' },
    disabled: clientProfile?.type ? clientTypeToSuitableCatalogItemType(clientProfile.type) !== catalogItem.type : false,
  };
  const EntityActions = isResume ? ResumeActions : VacancyActions;

  return (
    <Stack alignItems="center" direction="row" spacing={1.5} sx={sx}>
      <EntityActions catalogItem={catalogItem} {...buttonsProps} />
    </Stack>
  );
};
